// DOM builders for the web app (browser only; shared/format.ts has the pure formatters).

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string | number | boolean | EventListener | undefined> = {},
  ...children: Array<Node | string | null | undefined | false>
): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === false) continue;
    if (k.startsWith("on") && typeof v === "function") e.addEventListener(k.slice(2), v as EventListener);
    else if (k === "class") e.className = String(v);
    else if (v === true) e.setAttribute(k, "");
    else e.setAttribute(k, String(v));
  }
  for (const c of children) if (c != null && c !== false) e.append(c);
  return e;
}

/** Drop null/false entries so conditional children can be passed to append/replaceChildren. */
export const nodes = (...xs: Array<Node | string | null | undefined | false>): Array<Node | string> =>
  xs.filter((x): x is Node | string => x != null && x !== false);
